import { useSlateStatic } from "slate-react";
import { slateToText } from "../../utils/slateToText";

function SaveButton() {
  const editor = useSlateStatic();

  const handleClick = () => {
    const text = slateToText(editor.children);
    console.log("PLAIN TEXT:", text);

    // save to backend
    // fetch("/api/save", { method: "POST", body: JSON.stringify({ text }) });
  };

  return <button onClick={handleClick}>Save</button>;
}

export default SaveButton;
